import React, {Fragment} from 'react'
import {Select as AntSelect} from 'antd'
import {usePicker} from '@eitje/form'
import {t} from '@eitje/bridge'
import utils from '@eitje/utils'
import _ from 'lodash'

const {Option} = AntSelect

const searchOpts = {
	filterOption: (input, option) => {
		const normalized = utils.normalizeComparableString(option.children)
		return normalized.indexOf(utils.normalizeComparableString(input)) >= 0
	},
	optionFilterProp: 'children',
	showSearch: true,
}

const findKey = item => item.key || item.value

const DropdownPicker = props => {
	const {
		value,
		innerClass,
		label,
		readOnly,
		items = [],
		minSelected,
		error,
		multiple,
		showSearch = items.length > 5,
		style = {},
		selectAll,
		setOpen = _.noop,
		...rest
	} = props
	const {pickerItems, selectedBaseItem, selectedItems} = usePicker(props)
	const condOpts = showSearch ? searchOpts : {}
	if (readOnly) style['pointerEvents'] = 'none'

	const disallowRemove = minSelected && value && value.length <= minSelected

	if (disallowRemove) {
		condOpts['removeIcon'] = null
	}

	if (readOnly) condOpts['showArrow'] = false

	const _selectAll = (value, items) => {
		if (!utils.exists(value)) return props.onChange(items.map(i => i.value))
		return props.onChange(multiple ? [] : null)
	}
	const classNames = utils.makeCns(innerClass, 'eitje-dropdown')
	return (
		<Fragment>
			<AntSelect
				{...condOpts}
				style={style}
				mode={multiple ? 'multiple' : 'default'}
				onDropdownVisibleChange={setOpen}
				showAction="focus"
				{...rest}
				value={value}
				className={classNames}
			>
				{pickerItems.map((i, idx) => (
					<Option disabled={disallowRemove && value.includes(i.value)} key={findKey(i) || idx} value={i.value}>
						{i.label}
					</Option>
				))}
			</AntSelect>
			{selectAll && (
				<p onClick={() => _selectAll(value, pickerItems)} className="eitje-form-2-select-all">
					{t('common.select_all')}
				</p>
			)}
		</Fragment>
	)
}
export default DropdownPicker
